import { useEffect } from "react";
import { api } from "@/lib/apiClient";

const HEARTBEAT_MS = 20000;

function clientId() {
  let id = sessionStorage.getItem("hip_presence_id");
  if (!id) {
    id = (crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    sessionStorage.setItem("hip_presence_id", id);
  }
  return id;
}

// Announce "someone is on a pledge form" so the admin can check for live
// users before restarting the service. Fire-and-forget; failures ignored.
export function usePresence(page) {
  useEffect(() => {
    const beat = () => api.post("/presence/form", { client_id: clientId(), page }).catch(() => {});
    beat();
    const t = setInterval(beat, HEARTBEAT_MS);
    return () => clearInterval(t);
  }, [page]);
}
